import { ReactNode } from 'react'
import { Box, Card, Typography } from '@mui/material'
import { RouterLink } from '@/components/router-link'

type SummaryTileProps = {
  to: string
  icon: ReactNode
  label: ReactNode
}

export function SummaryTile({ to, icon, label }: SummaryTileProps) {
  return (
    <RouterLink to={to}>
      <Card>
        <Box
          textAlign="right"
          sx={{
            color: 'secondary.main',
            '& > .MuiSvgIcon-root': { fontSize: 32 },
          }}
        >
          {icon}
        </Box>
        <Typography fontSize={18}>{label}</Typography>
      </Card>
    </RouterLink>
  )
}
